import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { getFormValues, isDirty } from 'redux-form';
import { withRouter } from 'react-router';

import confirmModal from '../../../common/confirmModal';
import { STAFF_FORM } from './StaffFormContainer';

export const withGoToUrl = withHandlers({
  goToUrl: props => (url) => {
    props.router.setRouteLeaveHook(props.route, () => true);
    props.router.push(url);
  },
});

export default compose(
  withRouter,
  connect(state => ({
    isFormDirty: isDirty(STAFF_FORM)(state),
    formValues: getFormValues(STAFF_FORM)(state),
  })),
  withHandlers({
    routerWillLeave: props => (nextLocation) => {
      if (props.isFormDirty) {
        confirmModal(
          {
            title: 'Unsaved changes',
            message: 'Would you like to save the changes before leaving this page?',
            type: 'yesno',
            confirmButtonText: 'Yes',
            negativeButtonText: 'No',
          }
        ).then((confirmed) => {
          if (confirmed) {
            props.onSubmit(props.formValues, nextLocation.pathname);
          } else {
            props.goToUrl(nextLocation.pathname);
          }
        });

        return false;
      }

      return true;
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.router.setRouteLeaveHook(this.props.route, this.props.routerWillLeave);
    },
  }),
);
